<div class="one-column-page">
<div class="one-column-content">
  <h1>{{'SENSITIVITY.INPUT_SELECTION.HEADER' | anessaTranslation: trigger}}</h1>
  <p class="center section-padding">
<!--    select inputs to be used in the sensitivity analysis-->
    {{'SENSITIVITY.INPUT_SELECTION.DESCRIPTION' | anessaTranslation: trigger}}
  </p>
  <div class="flex-container section-padding">
    <div class="flex-box no-padding max-width">
      <mat-form-field floatLabel="never"
                      class="anessa-dropdown">
        <mat-select multiple
                    id="sensitivity-input_select"
                    disableOptionCentering
                    [placeholder]="'SENSITIVITY.INPUT_SELECTION.INPUTS_PLACEHOLDER' | anessaTranslation: trigger"
                    [(value)]="selectedInputData"
                    (valueChange)="setSelectedInputs()"
                    panelClass="anessa-dropdown-panel">
          <ngx-mat-select-search [placeholderLabel]="'RESULTS.GENERAL.SEARCH' | anessaTranslation: trigger"
                                 [noEntriesFoundLabel]="'SENSITIVITY.INPUT_SELECTION.NO_INPUTS_FOUND' | anessaTranslation: trigger"
                                 class="clear-search"
                                 [(ngModel)]="inputFilter"
                                 (ngModelChange)="filterInputs()">
            <i class="material-icons" ngxMatSelectSearchClear>
              delete
            </i>
          </ngx-mat-select-search>

          <mat-option *ngFor="let input of filteredInputsData"
                      [value]="input"
                      [disabled]="getDisabledState(input)"
          >
            {{ input.nameElements | anessaTranslation: trigger}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <form #sensForm="ngForm"
        (ngSubmit)="onSubmit()">
    <div #sensTable *ngIf="showTable && sensTableData.length > 0">
      <table mat-table [dataSource]="sensTableData" class="sens-table">
        <ng-container matColumnDef="variables">
          <th mat-header-cell
              *matHeaderCellDef
          > {{'SENSITIVITY.INPUT_SELECTION.VARIABLES' | anessaTranslation: trigger}} </th>
          <td mat-cell *matCellDef="let element">
            {{(element.id ? (element.nameElements | anessaTranslation: trigger) :
            ('SENSITIVITY.INPUT_SELECTION.NO_INPUTS_SELECTED' | anessaTranslation: trigger))}}</td>
        </ng-container>
        <ng-container matColumnDef="include">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              [(ngModel)]="allRowsSelected"
              [ngModelOptions]="{ standalone: true }"
              (change)="rowsCheckAll()"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox
              [(ngModel)]="sensTableRowsSelected[element.id]"
              [ngModelOptions]="{ standalone: true }"
              (change)="selectionChanged()"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="minimum">
          <th mat-header-cell
              *matHeaderCellDef
          > {{'SENSITIVITY.INPUT_SELECTION.MINIMUM' | anessaTranslation: trigger}} </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field [floatLabel]="'never'">
              <input type="number"
                     matInput
                     [(ngModel)]="element.min"
                     [disabled]="(!element.id)"
                     [placeholder]="(
                     element.id ? ('SENSITIVITY.INPUT_SELECTION.ENTER_VALUE' | anessaTranslation: trigger) :
                      ('SENSITIVITY.INPUT_SELECTION.N_A' | anessaTranslation: trigger)
                     )"
                     [name]="element.id + '-min'"
                     [id]="element.id + 'min'"
                     (input)="onInputChange(element, 'min')"
              >
              <mat-error>
                <div *ngFor="let error of element.minErrorHints" class="red-text">
                  {{ errorsHintsDict[error] | anessaTranslation: trigger}}
                </div>
              </mat-error>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="maximum">
          <th mat-header-cell
              *matHeaderCellDef
          > {{'SENSITIVITY.INPUT_SELECTION.MAXIMUM' | anessaTranslation: trigger}} </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field [floatLabel]="'never'">
              <input type="number"
                     matInput
                     [(ngModel)]="element.max"
                     [disabled]="(!element.id)"
                     [placeholder]="(
                     element.id ? ('SENSITIVITY.INPUT_SELECTION.ENTER_VALUE' | anessaTranslation: trigger) :
                      ('SENSITIVITY.INPUT_SELECTION.N_A' | anessaTranslation: trigger)
                     )"
                     [name]="element.id + '-max'"
                     [id]="element.id + 'max'"
                     (input)="onInputChange(element, 'max')"
              >
              <mat-error>
                <div *ngFor="let error of element.maxErrorHints" class="red-text">
                  {{ errorsHintsDict[error] | anessaTranslation: trigger}}
                </div>
              </mat-error>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="intervals">
          <th mat-header-cell
              *matHeaderCellDef
          > {{'SENSITIVITY.INPUT_SELECTION.NO_OF_INTERVALS' | anessaTranslation: trigger}} </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field [floatLabel]="'never'">
              <input type="number"
                     matInput
                     [(ngModel)]="element.interval"
                     [disabled]="(!element.id)"
                     [placeholder]="(
                     element.id ? ('SENSITIVITY.INPUT_SELECTION.ENTER_VALUE' | anessaTranslation: trigger) :
                      ('SENSITIVITY.INPUT_SELECTION.N_A' | anessaTranslation: trigger)
                     )"
                     [name]="element.id + '-interval'"
                     [id]="element.id + 'interval'"
                     (input)="onInputChange(element)"
              >
              <mat-error>
                <div *ngFor="let error of element.intervalErrorHints" class="red-text">
                  {{ errorsHintsDict[error] | anessaTranslation: trigger}}
                </div>
              </mat-error>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="value">
          <th mat-header-cell
              *matHeaderCellDef
          > {{'RESULTS.GENERAL.VALUE' | anessaTranslation: trigger}} </th>
          <td mat-cell *matCellDef="let element">
            {{(checkIfNum(element.value) ? element.value :
            ('SENSITIVITY.INPUT_SELECTION.N_A' | anessaTranslation: trigger))
            }} </td>
        </ng-container>
        <ng-container matColumnDef="unit">
          <th mat-header-cell
              *matHeaderCellDef
          > {{'RESULTS.GENERAL.UNIT' | anessaTranslation: trigger}} </th>
          <td mat-cell *matCellDef="let element">
            <div [innerHTML]="element.unit ? (processUnitName(element.unit)) :
            ('SENSITIVITY.INPUT_SELECTION.N_A' | anessaTranslation: trigger)"
            ></div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="sensTableHeaders; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: sensTableHeaders;"></tr>
      </table>
    </div>
    <div *ngIf="sensForm['form'].invalid || formErrors.length > 0">
      <br><br>
      <ul>
        <p *ngFor="let errorName of formErrors" class="red-text">
          {{ errorsSummaryDict[errorName] | anessaTranslation: trigger}}
        </p>
      </ul>
    </div>
    <div class="section-padding border-shadow apply-section">
      <div class="flex-container">
        <div class="flex-box input-container">
          <div class="flex-container flex-align-item-center">
            <p>{{'SENSITIVITY.INPUT_SELECTION.PERCENT_CHANGE' | anessaTranslation: trigger}}</p>
            <i class="material-icons apply-icon"
               [matTooltip]="'SENSITIVITY.INPUT_SELECTION.PERCENT_CHANGE_HELP' | anessaTranslation: trigger"
            >help</i>
          </div>
          <mat-form-field>
            <input id="sensitivity-input-percentChange_input"
                   type="number"
                   matInput
                   [(ngModel)]="changePercent.value"
                   name="changePercent"
                   (input)="checkInput(changePercent)"
            >
            <mat-error>
              <div *ngFor="let error of changePercent.errors" class="red-text">
                {{ errorsHintsDict[error] | anessaTranslation: trigger}}
              </div>
            </mat-error>
            <div matSuffix class="edit-caption">
              %
            </div>
          </mat-form-field>
        </div>
      </div>
      <div>
        <button
          id="sensitivity-input-applyToAll_button"
          mat-button
          class="apply-button"
          type="button"
          (click)="applyToAll()"
          [disabled]="changePercent.errors.length > 0"
        >{{
          (selectedCount > 0) ? ('SENSITIVITY.INPUT_SELECTION.APPLY_TO_SELECTED' | anessaTranslation: trigger) :
            ('SENSITIVITY.INPUT_SELECTION.APPLY_TO_ALL' | anessaTranslation: trigger)
          }}</button>
      </div>
    </div>
    <div class="fatbuttongroup relative-container">
      <button id="sensitivity-input-save_button"
              type="submit"
              mat-button
              class="mat-mdc-button btn-green btn-fat"
              [disabled]="formErrors.length > 0"
      >{{'PROJECT.COMMON.SAVE' | anessaTranslation: trigger}}</button>
      <div class="tooltip-popup"
           *ngIf="displaySavePopup">
        <p>{{'SENSITIVITY.INPUT_SELECTION.SAVE_WARNING' | anessaTranslation: trigger}}</p>
        <div class="tooltip-buttons">
          <a id="sensitivity-input-confirmSave_button"
             class="mat-raised-button btn-green"
             mat-raised-button
             (click)="onSaveSensitivity()"
          >{{'PROJECT.COMMON.YES' | anessaTranslation: trigger}}</a>
          <a id="sensitivity-input-cancelSave_button"
             class="mat-raised-button btn-red"
             mat-raised-button
             (click)="onSaveCancel()"
          >{{'PROJECT.COMMON.NO' | anessaTranslation: trigger}}</a>
        </div>
      </div>
      <button
        id="sensitivity-input-reset_button"
        type="button"
        class="mat-mdc-button btn-red btn-fat"
        mat-button
        (click)="displayResetPopup = true">
        {{ (selectedCount > 0) ? ('SENSITIVITY.INPUT_SELECTION.RESET_SELECTED' | anessaTranslation: trigger) :
        ('SENSITIVITY.INPUT_SELECTION.RESET' | anessaTranslation: trigger) }}
      </button>
      <div class="tooltip-popup"
           *ngIf="displayResetPopup">
        <p>
          {{ (selectedCount > 0) ? ('SENSITIVITY.INPUT_SELECTION.CONFIRM_RESET_SELECTED' | anessaTranslation: trigger) :
          ('SENSITIVITY.INPUT_SELECTION.CONFIRM_RESET_ALL' | anessaTranslation: trigger) }}
        </p>
        <div class="tooltip-buttons">
          <a id="sensitivity-input-confirmReset_button"
            class="mat-raised-button btn-green"
             mat-raised-button
             (click)="resetValues()">{{'PROJECT.COMMON.YES' | anessaTranslation: trigger}}</a>
          <a id="sensitivity-input-cancelReset_button"
             class="mat-raised-button btn-red"
             mat-raised-button
             (click)="displayResetPopup = false">{{'PROJECT.COMMON.NO' | anessaTranslation: trigger}}</a>
        </div>
      </div>
    </div>
  </form>
</div>
</div>
